export function cleanPhone(numero: string | null | undefined): string {
  return String(numero ?? '').replace(/\D/g, '');
}

export function whatsappUrl(numero: string | null | undefined): string {
  const clean = cleanPhone(numero);
  if (!clean) return '';
  const withCountry = clean.startsWith('55') ? clean : `55${clean}`;
  return `https://wa.me/${withCountry}`;
}

export function formatPhone(numero: string | null | undefined): string {
  const d = cleanPhone(numero);
  if (!d) return '';
  if (d.length === 13 && d.startsWith('55')) {
    return `+55 (${d.slice(2, 4)}) ${d.slice(4, 9)}-${d.slice(9)}`;
  }
  if (d.length === 12 && d.startsWith('55')) {
    return `+55 (${d.slice(2, 4)}) ${d.slice(4, 8)}-${d.slice(8)}`;
  }
  if (d.length === 11) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  }
  if (d.length === 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  if (d.length === 9) {
    return `${d.slice(0, 5)}-${d.slice(5)}`;
  }
  if (d.length === 8) {
    return `${d.slice(0, 4)}-${d.slice(4)}`;
  }
  return numero ?? '';
}
